export default {
  /*
    Original Sediments
    CAUTION!! Now not using!!
  /*---------------------------------------*/
  sediment_defs: [
    {
      group: 'sediment',
      name: '',
      path: 'yokote_gakekuzure_red.geojson',
      color: 'red',
    },
    {
      group: 'sediment',
      name: '',
      path: 'yokote_gakekuzure_yellow.geojson',
      color: 'yellow',
    },
    {
      group: 'sediment',
      name: '',
      path: 'yokote_dosekiryu_red.geojson',
      color: '#326f3e',
    },
    {
      group: 'sediment',
      name: '',
      path: 'yokote_dosekiryu_yellow.geojson',
      color: '#4295a5',
    },
    {
      group: 'sediment',
      name: '',
      path: 'yokote_jisuberi.geojson',
      color: '#b22d5b',
    },
  ],

  /*
    Guides 
  /*---------------------------------------*/
  guides: {
    flood: [
      // {color: '#f9c2e4', label: '10m以上20m未満'},
      { color: '#ffc8c8', label: '5m以上10m未満' },
      { color: '#ffdbdc', label: '3m以上5m未満' },
      { color: '#ffede0', label: '0.5m以上3m未満' },
      { color: '#fbfad5', label: '0m以上0.5m未満' },
    ],
    sediment: [
      { color: 'red', label: 'がけ崩れ特別警戒区域' },
      { color: 'yellow', label: 'がけ崩れ警戒区域' },
      { color: '#326f3e', label: '土石流特別警戒区域' },
      { color: '#4295a5', label: '土石流警戒区域' },
      { color: '#b22d5b', label: '地すべり警戒区域' },
    ],
    ekijyoka: [
      { color: '#e73323', label: '極めて高い' },
      { color: '#fefe54', label: '高い' },
      { color: '#73f84d', label: '低い' },
      { color: '#bee0fc', label: '極めて低い' },
    ],
  },

  /*
    Icons 
  /*---------------------------------------*/
  icons: {
    current_position: {
      fillColor: '#1e87f0',
      fillOpacity: 1,
      strokeWeight: 0,
      path:
        'M367.9 329.76c-4.62 5.3-9.78 10.1-15.9 13.65v22.94c66.52 9.34 112 28.05 112 49.65 0 30.93-93.12 56-208 56S48 446.93 48 416c0-21.6 45.48-40.3 112-49.65v-22.94c-6.12-3.55-11.28-8.35-15.9-13.65C58.87 345.34 0 378.05 0 416c0 53.02 114.62 96 256 96s256-42.98 256-96c0-37.95-58.87-70.66-144.1-86.24zM256 128c35.35 0 64-28.65 64-64S291.35 0 256 0s-64 28.65-64 64 28.65 64 64 64zm-64 192v96c0 17.67 14.33 32 32 32h64c17.67 0 32-14.33 32-32v-96c17.67 0 32-14.33 32-32v-96c0-26.51-21.49-48-48-48h-11.8c-11.07 5.03-23.26 8-36.2 8s-25.13-2.97-36.2-8H208c-26.51 0-48 21.49-48 48v96c0 17.67 14.33 32 32 32z',
      scale: 0.1,
    },
    shelter: L.icon({
      iconUrl: `${baseUrl}/assets/map/shelter.png`,
      shadowUrl: `${baseUrl}/assets/map/shelter_shadow.png`,
      iconSize: [46, 64],
      shadowSize: [46, 48],
      iconAnchor: [23, 64],
      shadowAnchor: [4, 48],
      popupAnchor: [0, -65],
    }),
    closed_shelter: L.icon({
      iconUrl: `${baseUrl}/assets/map/closed_shelter.png`,
      shadowUrl: `${baseUrl}/assets/map/closed_shelter_shadow.png`,
      iconSize: [48, 48],
      shadowSize: [46, 43],
      iconAnchor: [24, 48],
      shadowAnchor: [4, 43],
      popupAnchor: [0, -49],
    }),
  },

  /*
    Map Style 
  /*---------------------------------------*/
  style: [
    {
      featureType: 'poi.medical',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#ebebeb',
        },
      ],
    },
  ],

  /*
    Area limit
    Set true before deploy to restore map movement and tile bounds.
  /*---------------------------------------*/
  area_limit_is_enabled: false,

  /*
    Bounds for tile
  /*---------------------------------------*/
  bounds: {
    10: [
      [911, 912],
      [389, 390],
    ],
    11: [
      [1822, 1826],
      [779, 781],
    ],
    12: [
      [3645, 3650],
      [1559, 1562],
    ],
    // 13: [
    //   [7290, 7296],
    //   [3119, 3125],
    // ],
    // 14: [
    //   [14580, 14591],
    //   [6238, 6250],
    // ],
  },

  /*
    Bounds for limit 
  /*---------------------------------------*/
  bound_for_limit: {
    north: 39.47797332740886,
    west: 140.15497979197158,
    south: 39.1018822231641,
    east: 140.95538878036163,
  },

  /*
    Attribution 
  /*---------------------------------------*/
  attribution: `出典: <a href='https://www.jma.go.jp/jma/index.html' target='_blank'>気象庁ホームページ</a>`,
  // , <a href='https://maps.gsi.go.jp/development/ichiran.html' target='_blank'>国土地理院</a>

  /*
    Shelter Popup Content 
  /*---------------------------------------*/
  shelter_popup_content: function(shelter, shelter_types, current_position) {
    const data_type =
      shelter.hasOwnProperty('data_type') && shelter.data_type === 'shelter' ? 'shelter' : 'kml';

    //- Common Content
    const header_nav = [];
    if (shelter.tel)
      header_nav.push(
        `<a href="tel:${shelter.tel.replace(
          /-/g,
          ''
        )}"><img src="${baseUrl}/assets/map/tel.jpg" alt="電話をかける" style="width: 100%; min-width: 40px; max-width: 50px"></a>`
      );

    if (current_position && shelter.latlng) {
      const route_url = `https://www.google.com/maps/dir/?api=1&origin=${current_position.lat},${current_position.lng}&destination=${shelter.latlng.lat},${shelter.latlng.lng}&travelmode=walking`;
      header_nav.push(
        `<a href="${route_url}" target="_blank" rel="noopener noreferrer"><img src="${baseUrl}/assets/map/route.jpg" alt="経路を表示"/ style="width: 100%; min-width: 40px; max-width: 50px"></a>`
      );
    }

    const contents = [
      `<div class="uk-flex uk-flex-between uk-flex-middle uk-grid-small" uk-grid>`,
      `<div class="uk-width-1-1 uk-width-expand@s uk-text-bold uk-h2 uk-margin-remove" style="margin-top: 12px">${shelter.name}</div>`,
      `<div class="uk-width-1-1 uk-width-auto@s">${header_nav.join('')}</div>`,
      `</div>`,
      `<hr style="border-top: solid 3px; border-radius: 3px">`,
    ];

    //- Types and Equipments
    if (data_type === 'shelter') {
      //- Types
      contents.push('<div class="uk-grid-small uk-child-width-1-6 uk-flex">');
      //- Shelter Types
      const _shelter_types = shelter_types.map((key) => {
        const _icon = ['<div>'];
        _icon.push(
          `<img src="${baseUrl}/assets/map/types/${key}.jpg" loading="lazy" class="uk-width-1-1" style="min-width: 30px; max-width: 60px">`
        );
        const _state = shelter[key] == 1 ? 'ok' : 'ng';
        _icon.push(
          `<div style="padding: 5px; min-width: 30px; max-width: 60px; box-sizing: border-box"><img src="${baseUrl}/assets/map/types/${_state}.jpg" loading="lazy" class="uk-width-1-1"></div>`
        );
        _icon.push('</div>');
        return _icon.join('');
      });
      contents.push(_shelter_types.join(''));
      contents.push('</div>');
      contents.push(`<hr style="border-top: solid 3px; border-radius: 3px">`);

      //- Equipments
      contents.push('<div class="uk-grid-small uk-flex uk-flex-wrap">');
      const equipments = shelter.equipments.map((equipment) => {
        return `<div class="uk-width-auto">
          <img src="${equipment.path}?20210626" alt="${equipment.name}" width="40" loading="lazy"/>
        </div>`;
      });
      if (equipments.length > 0) {
        contents.push(equipments.join(''));
      }
      contents.push('</div>');
    }

    //- Remarks
    if (shelter.remarks) {
      const remarks = [
        `<div class="map-tooltip__title">備考</div>`,
        `<div>${shelter.remarks}</div>`,
      ];
      contents.push(remarks.join(''));
    }

    //- Create
    return contents.join('');
  },

  /*
    Custom Layer 
  /*---------------------------------------*/
  custom_layer_popup_content: function(custom_layer) {
    //- Common Content
    const contents = [
      `<div class="uk-text-bold uk-h2 uk-margin-remove" style="margin-top: 12px">${custom_layer.name}</div>`,
      `<hr style="border-top: solid 3px; border-radius: 3px">`,
    ];

    //- Remarks
    if (custom_layer.remarks) {
      const remarks = [
        `<div class="map-tooltip__title">備考</div>`,
        `<div>${custom_layer.remarks}</div>`,
      ];
      contents.push(remarks.join(''));
    }

    //- Create
    return contents.join('');
  },

  /**
   * Tameike Layer Popup
   */
  tameike_layer_popup_content: function(tameike) {
    //- Common Content
    const contents = [
      `<div class="uk-text-bold uk-h4 uk-margin-remove" style="margin-top: 12px">${tameike.name}</div>`,
    ];

    //- Create
    return contents.join('');
  },
};
